module.exports = __webpack_public_path__ + "static/media/plus_icon.d21f598a.svg";